import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Config } from 'ionic-angular';

import { RoomOfferModel } from '../../app/models/room-offer-model';

import { RoomOffersService } from '../../providers/room-offers-service/room-offers-service';

@Injectable()
export class RestRoomOffersService implements RoomOffersService {
  private serverUrl : string;

  constructor(private http: Http, configuration: Config) {
    this.serverUrl = configuration.get('backendUrl');
  }

  public findOffersForEvent(eventCode : string) : Observable<RoomOfferModel[]> {
    return Observable.create(observer => {
	  this.http.get(this.serverUrl+'/api/'+eventCode+'/rooms/')
        .map(res => this.adaptFromRemoteRoomOffers(res.json()))
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(error);
        });
    });
  }

  private adaptFromRemoteRoomOffers(rooms: any) : RoomOfferModel[] {
    return null;//FIXME: real implementation
	}

  private handleError(error) {
    console.error(error);
    return Observable.throw((error.status === 404 ? error.text() : error.json().error) || 'Server error while reading news data');
  }

}



// WEBPACK FOOTER //
// ./src/providers/room-offers-service/rest-room-offers-service.ts